export default {
  clean: () => import("/tmp/build_fab81756/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/tmp/build_fab81756/layouts/default.vue").then(m => m.default || m)
}